/** @format */
import { css } from 'styled-components';

import { BasketEmptyMessageProps } from './index';

/**
 * Base styles for the basket empty message component
 *
 * @param {BasketEmptyMessageProps} props The basket empty message properties object
 * */
const baseStyles = (props: BasketEmptyMessageProps) => css`
    .basket-empty-message {
        padding: var(--layout-spacing-24);
        text-align: center;

        .basket-empty-message-cta {
            display: inline-block;
            margin-top: var(--layout-spacing-12);
        }
    }
`;

/**
 * The basket empty message component styles
 *
 * @param {BasketEmptyMessageProps} props The basket empty message properties object
 * */
export const styles = (props: BasketEmptyMessageProps) => css`
    ${baseStyles(props)}
`;
